/**
 * 步骤四视频生成失败：映射为用户可见短提示（≤10 字）。
 * 与后端 PipelineErrorLogService::mapStep4VideoUserHint 规则保持一致。
 */
export function mapStep4VideoErrorHint(raw) {
  const s = String(raw || "").trim();
  if (!s) return "生成失败";
  if (/积分不足/.test(s)) return "积分不足";
  if (/真人|人像|包含真人|含真人|real[\s_-]*person|realistic[\s_-]*person/i.test(s)) {
    return "含真人图";
  }
  if (/视频违规/.test(s)) return "视频违规";
  if (/内容违规/.test(s)) return "内容违规";
  if (/违规/.test(s)) return "内容违规";
  if (/版权/.test(s)) return "版权限制";
  if (/参数错误|分镜不存在|项目不存在|请先填写|视频任务创建失败/.test(s)) {
    return s.length <= 10 ? s : s.slice(0, 10);
  }
  if (/视频任务超时|生成耗时较长/.test(s)) return s.length <= 10 ? s : s.slice(0, 10);
  if (s !== "生成失败" && s.length <= 10) return s;
  return "生成失败";
}

export function alertStep4VideoError(raw) {
  window.alert(mapStep4VideoErrorHint(raw));
}
